import { LoanPurpose } from "projects/borrower-app/src/app/models/enums/loan-purpose.enum";
import { Occupancy } from "projects/borrower-app/src/app/models/enums/occupancy.enum";
import { PropertyType } from "projects/borrower-app/src/app/models/enums/property-type.enum";

export class SubjectProperty {
  purposeOfLoan: LoanPurpose | undefined;
  propertyWillBe: Occupancy | undefined;
  propertyType: PropertyType | undefined;
  projectType: string | undefined;
  attachmentType: string | undefined;
  downPaymentSource: string | undefined | null = null;
  presentValue?: number | undefined | null;
  yearBuilt: number | undefined;
  noOfUnits: number | undefined;

  originalCost: number | undefined;
  originalCostYear: number | undefined;

  address1: string = "";
  address2: string = "";
  city: string = "";
  state: string = "";
  zipCode: string = "";
  county: string = "";

  landType: string | undefined;
  sizeOfLand: string | undefined;
  estimatedLandValue: number | undefined;
  amountOwned: number | undefined;
  manufacturedHomeMake: string | undefined;
  manufacturedHomeModel: string | undefined;
  manufacturedHomeSalesPrice: number | undefined;
  manufacturedHomePriceOfHome: number | undefined;
  manufacturedHomeLotOwnershipType: string | undefined;
  manufacturedHomeLotRentalAmount: number | undefined;

  // URLA 2020 — Loan & Property Info. "Type of Refinance" and "Purpose of Refinance"
  // surface on the Property Address Refi step when admin-configured to be visible.
  refiPurpose: string | undefined;
  refinancePrimaryPurpose: string | undefined;

  constructor() {
    this.downPaymentSource = null;
  }
}

